import ToggleBtn from './toggleBtn';
import { throttle } from '../utils';

import config from '../config';
const { breakpoints } = config;

const $win = $(window);
const $doc = $(document);

export default class Menu extends ToggleBtn {
    constructor() {
        const $header = $('.header');
        const $nav = $header.find('.nav');
        const $btn = $header.find('.menu-btn');

        super({
            triggerElement: $btn,
            toggleElement: $nav,
            isShowed: $win.width() >= breakpoints.lg ? true : false
        });

        this.$header = $header;

        this.init();
    }

    _bodyClickHandler = ({ target }) => {
        if ($win.width() >= breakpoints.lg) return;

        const clickInHeader = this.$header.has($(target)).length;
        this.isShowed && !clickInHeader && this.hide();
    }


    _windowResizeHandler = () => {
        $win.width() <= breakpoints.lg ? this.hide() : this.show();
    }

    init() {
        super.init();
        $win.on('resize', throttle(this._windowResizeHandler));
        $doc.on('click', this._bodyClickHandler);
    }
}



// WEBPACK FOOTER //
// ./components/menu.js